import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";
import { getCredentials } from "../AccessGuard/index.js";
import { withLocalDeadlineFallback } from "./localDeadlineFallback.js";
import { withClaimFormGate } from "./claimFormGate.js";

export class customSubmitClaim extends withClaimFormGate(SubmitClaim) {
    constructor(...args) {
        super(...args);
        this.claim.api = withLocalDeadlineFallback(this.claim.api);
    }

    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
        this._autoAuthFromDOE();
    }

    /**
     * Auto-fill and auto-submit the guard form using DOE session credentials.
     * Uses a MutationObserver to detect when the guard form is rendered
     * (after the async claimsDeadlineGet resolves in init_claim).
     * @private
     */
    _autoAuthFromDOE() {
        const creds = getCredentials();
        if (!creds.zero_zero_id || !creds.confirmation_code) return;

        const observer = new MutationObserver((mutations, obs) => {
            const guardForm = document.getElementById("guard");
            if (!guardForm) return;

            obs.disconnect();

            const zeroZeroId = document.getElementById("zero_zero_id");
            const confirmationCode = document.getElementById("confirmation_code");
            if (!zeroZeroId || !confirmationCode) return;

            // Auto-fill from DOE session
            zeroZeroId.value = creds.zero_zero_id;
            confirmationCode.value = creds.confirmation_code;

            // Auto-submit — triggers the existing guard submit handler
            guardForm.dispatchEvent(new Event("submit", { cancelable: true }));
        });

        observer.observe(document.body || document.documentElement, {
            childList: true,
            subtree: true,
        });
    }

    /**
     * Override send_otp to bypass email OTP for DOE-authenticated sessions.
     * DOE already verified the user via SMS/call-center OTP — no need for
     * a second OTP challenge on the FPA claim form.
     */
    send_otp(form, container, class_member, claim_deadline) {
        const creds = getCredentials();
        if (creds.zero_zero_id && creds.confirmation_code) {
            // DOE-authenticated — skip OTP, go straight to claim form
            this.populate_claim_form(form, container, class_member, claim_deadline);
            return;
        }
        // Fallback to default OTP flow
        super.send_otp(form, container, class_member, claim_deadline);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
